import React from 'react';
import { RouteProps } from 'react-router';
import { PermissionRuleName } from 'constant';
import { usePermissionForRule } from 'hooks/permissions/use-permission';
import { NotFound } from './404';
import { CustomSecureRoute } from './custom-secure-route';

export interface PermissionRouteProps extends RouteProps {
  ruleName?: PermissionRuleName;
}
export const SecureRoute = (props: PermissionRouteProps) => {
  const { ruleName, ...rest } = props;
  const { isAllowedForCurrentUser } = usePermissionForRule();

  return ruleName == null || isAllowedForCurrentUser(ruleName) ? (
    <CustomSecureRoute {...rest} />
  ) : (
    <NotFound />
  );
};
